<template>
  <div class="animated fadeIn">
    <div class="card card-yellow">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-2">
            <b-form-select :options="status" v-model="childStatus" value-field="value" text-field="text"></b-form-select>
          </div>
          <div class="col-2">
            <b-form-input :placeholder="$t('SEARCH')" v-model="searchQuerry" type="text" ></b-form-input>
          </div>
          <div class="col-2">
              <lb-vue-select v-model= "logopedId"
                              :list= "users.root"
                              :totalCount= "users.totalCount"
                              display-field= "username"
                              value-field= "userId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('USERS')">
                </lb-vue-select>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="card-body table-logoped" v-if="response.root != null">
              <grid
                  :data="response.root"
                  ref="child"
                  v-model="pagination"
                  :columns="columns"
                  :totalCount="response.totalCount"
                  gridId="childsGrid">
                    <template v-slot="{item, column}">
                        <template v-if="column.id == 'name'">
                            <router-link :to="'/admin/children/child/childdetails/'+ item.childId">
                                {{item.name}}
                            </router-link>
                        </template>
                        <template v-if="column.id == 'actions'">
                                <button type="button" class="btn btn-primary mr-2 button-save"  @click="showChildDetails(item.childId)">{{$t('INFO')}}</button>
                                <button type="button" class="btn mr-2 button-edit"  @click="showModal(item)">{{$t('EDIT')}}</button>
                                <button type="button" class="btn button-dlt" @click="deleteRow(item.childId)">{{$t('DELETE')}}</button>
                            </template>
                    </template>
              </grid>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('CHILDFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop @close="hideModal()">
      <div class="d-block">
        <childform v-bind:formData="formData" v-bind:formError="formError"></childform>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 btn button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import moment from 'moment';
import Api from '@/api/child/Child';
import UsersApi from '@/api/admin/Users';
import ChildForm from './Form.vue';

export default
{
    name: 'Child',
    components:
  {
      childform: ChildForm,
  },
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    id: 'name',
                    key: 'name',
                    name: me.$t('NAME'),
                    handler()
                    {
                        return '';
                    },
                },
                {
                    key: 'surname',
                    name: me.$t('SURNAME'),
                },
                {
                    key: 'isKindergarten',
                    name: me.$t('ISKINDERGARTEN'),
                    handler(item)
                    {
                        if (item.isKindergarten === 1)
                        {
                            return me.$t('YES');
                        }
                        return me.$t('NO');
                    },
                },
                {
                    key: 'kindergartenName',
                    name: me.$t('KINDERGARTENNAME'),
                },
                {
                    key: 'birthDate',
                    name: me.$t('BIRTHDATE'),
                    handler(item)
                    {
                        return moment(item.birthDate).format('DD.MM.YYYY');
                    },
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            response:
      {},
            formError:
      {},
            childStatus: 'active',
            logopedId: 0,
            users: {},
            searchQuerry: '',
            formData:
      {
          name: '',
          surname: '',
          birthDate: null,
          parentId: null,
          isKindergarten: 0,
          kindergartenName: '',
          note: '',
          anamnestic: '',
          communication: '',
          instrument: '',
          opinion: '',
          status: 'active',
          diagnoseId: null,
          userId: null,
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          companyId: '',
          initialId: null,
          sort: null,
          readingType: null,
      },
            status:
      [
          {
              value: 'active',
              text: me.$i18n.t('ACTIVE'),
          },
          {
              value: 'inactive',
              text: me.$i18n.t('INACTIVE'),
          },
      ],
        };
    },
    created()
    {
        const me = this;

        me.logopedId = me.globals.userId;
        me.getData();
        me.getUsers();
    },
    methods:
  {
      showChildDetails(id)
      {
          const me = this;
          me.$router.push(
              {
                  path: `/admin/children/child/childdetails/${id}`,
              },
          );
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.childId !== 'undefined')
              {
                  item.id = item.childId;
                  delete (item.childId);
              }

              item.birthDate = moment(item.birthDate).format('YYYY-MM-DD');
              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              parentId: null,
              isKindergarten: 0,
              kindergartenName: '',
              note: '',
              anamnestic: '',
              communication: '',
              instrument: '',
              opinion: '',
              userId: null,
          };
      },
      async getUsers()
      {
          const me = this;
          try
          {
              const data = await UsersApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              for (let i = 0; i < data.root.length; i += 1)
              {
                  data.root[i].password = '';
                  data.root[i].trhidden = false;
              }

              data.root.push({
                  userId: 0,
                  username: 'All',
              });

              me.users = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
  },
    watch:
  {
      pagination:
    {
        deep: true,
        handler()
        {
            const me = this;

            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }

            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
    },
      childStatus()
      {
          const me = this;
          me.getData();
      },
      logopedId()
      {
          const me = this;
          me.getData();
      },
      searchQuerry()
      {
        const me = this;

        if (me.searchTimeout !== false)
        {
            clearTimeout(me.searchTimeout);
        }

        me.searchTimeout = setTimeout(() =>
        {
            me.getData();
            me.searchTimeout = false;
        }, 300);
      }
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.status = me.childStatus;
          data.userId = me.logopedId;
          data.searchQuerry = me.searchQuerry;
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
